import { useState } from 'react';
import { css } from '@emotion/react';
import { saveAs } from 'file-saver';
import { Icon, IconName } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { NakedButton } from '../../../naked';
import { useTooltip } from '../../tooltip';
import { useImagePreviewActions, useImagePreviewValues } from '../provider/image-preview.provider';
import { controlStyles } from './constants';
import { ZoomSlider } from './zoom-slider';

interface ControlIconProps {
  name: IconName;
  onClick: () => void;
  tooltipMessage?: string;
}

const ControlIcon = ({ name, onClick, tooltipMessage }: ControlIconProps) => {
  const { tooltipProps, triggerProps, Tooltip } = useTooltip();
  const [hovered, setHovered] = useState(false);
  return (
    <>
      <NakedButton
        {...triggerProps}
        css={[
          controlStyles,
          css`
            width: fit-content;
            &:hover {
              background: ${theme.colors.white};
              transition: all 0.2s ease;
            }
          `,
        ]}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        onClick={onClick}
      >
        <Icon name={name} color={hovered ? 'default' : 'white'} css={{ background: 'transparent', padding: '0' }} />
      </NakedButton>
      {tooltipMessage && <Tooltip {...tooltipProps}>{tooltipMessage}</Tooltip>}
    </>
  );
};

export const Controls = () => {
  const { src, rotationDegree } = useImagePreviewValues();
  const { setRotationDegree } = useImagePreviewActions();

  //*This is a temporary check until we find a way on how to handle this inside the electron shell */
  //@ts-ignore since window.shell is defined in the electron environment
  const showPopout = typeof window !== 'undefined' && !window.shell?.isShell;

  return (
    <div
      css={{
        display: 'flex',
        width: '100%',
        alignItems: 'flex-end',
      }}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <div
        css={{
          display: 'flex',
          gap: theme.spacing(0.5),
          width: '100%',
          justifyContent: 'center',
        }}
      >
        <ControlIcon
          name='update-small'
          onClick={() => setRotationDegree((rotationDegree + 90) % 360)}
          tooltipMessage='Rotate'
        />
        <ZoomSlider />
        <ControlIcon name='download-small' onClick={() => saveAs(src)} tooltipMessage='Download' />
        {showPopout && (
          <ControlIcon name='pop-out-small' onClick={() => open(src, '_blank')} tooltipMessage={'Open in new window'} />
        )}
      </div>
    </div>
  );
};

Controls.displayName = 'Controls';
